const owner = {
  //项目推广
  path: 'expand',
  component: () => import("@/views/member/expand/expand"),
  meta: {
    tabBar: false
  },
  children:[
    {
      path: 'agency',
      component: () => import("@/views/member/expand/agency"),
      meta: {
        tabBar: false
      }
    },
    {
      path: 'editcard',
      component: () => import("@/views/member/expand/editcard"),
      meta: {
        tabBar: false
      }
    },
  ]
};

export default owner;
